// extracted by mini-css-extract-plugin
module.exports = {"title":"NoInternetModal_title__1aJyv","content":"NoInternetModal_content__1_OC-"};